import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

const BASE_API =
  process.env.BASE_API_URL ||
  "https://scanmymenu-nm38.onrender.com/api";

export default function RestaurantDetails() {

  const { id } = useParams();

  const [restaurant, setRestaurant] = useState(null);

useEffect(() => {
  const fetchDetails = async () => {
    try {
      const res = await axios.get(
        `${BASE_API}/restaurants/${id}`
      );
      setRestaurant(res.data);
    } catch (err) {
      console.log("Error fetching details");
    }
  };

  fetchDetails();
}, [id]);

  if (!restaurant) return <p>Loading...</p>;

  return (
    <div style={{ padding: "20px" }}>

      <h1>Restaurant Details</h1>

      <p><b>Id:</b> {restaurant._id}</p>

      <a href={restaurant.menuUrl} target="_blank" rel="noopener noreferrer">
        View Menu
      </a>

      <h2>{restaurant.restaurantName}</h2>



      <img
        src={restaurant.logoUrl}
        alt="logo"
        width="120"
      />

      <p><b>Address:</b> {restaurant.restaurantAddress}</p>
      <p><b>Phone:</b> {restaurant.phone}</p>
      <p><b>Email:</b> {restaurant.email}</p>
      <p><b>Category:</b> {restaurant.category}</p>
      <p><b>City:</b> {restaurant.city}</p>
      <p><b>Status:</b> {restaurant.subscriptionStatus}</p>

      <h3>Menu Items</h3>

      {restaurant.items?.map(item => (
        <div key={item.itemId}>
          <p>{item.name} - ₹{item.price}</p>
        </div>
      ))}

   <pre>
  {JSON.stringify(restaurant, null, 2)}
</pre>


    </div>
  );
}